jQuery.fn.boxify = function( options ) {

    // Bob's default settings:
    var defaults = {
        wrapperClass:'boxify-wrapper',
        selectorClass:'boxify-selector'
    };

    var settings = $.extend( {}, defaults, options );

    return this.each(function() {

        $(this).wrap('<div class="'+settings.wrapperClass+'"></div>');

        var $this = $(this);
        var $wrapper = $this.parent();
        var curVal;


        $this.find('option').each(function(){
          console.log($this)
          $this.parent().append('<span class="'+settings.selectorClass+'" data-value="'+$(this).val()+'">'+$(this).text()+'</span>');
        });

        $wrapper.find('.'+settings.selectorClass).click(function(){

          var val = $wrapper.find('option[value="'+$(this).data('value')+'"]').val();

          $wrapper.find('select').val(val).change();

          onSelect();

        });

        $wrapper.find('.'+settings.selectorClass+'[data-value="'+curVal+'"]').addClass('current');

        function onSelect(){

          curVal = $wrapper.find('select').val();

          $wrapper.find('.'+settings.selectorClass).removeClass('current');
          $wrapper.find('.'+settings.selectorClass+'[data-value="'+curVal+'"]').addClass('current');

        }

        function onInit(){

          onSelect();

        }

        onInit();


    });

};
